export default __webpack_public_path__ + "static/car_seat_icon_purple-1f46a5fd58ecf7ebb284eb99084f2fe5.png";